export default __webpack_public_path__ + "static/media/loading.91cabcc8.png";